import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import AuthLayout, { AuthField, EMAIL_RE, EMAIL_ERR } from './AuthLayout';
import { passwordApi } from '../api/services';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const ok = EMAIL_RE.test(email);

    const submit = async (e) => {
        e.preventDefault();
        if (!ok) return;
        setLoading(true);
        try {
            await passwordApi.request(email);
            setDone(true);
        } catch { /* toast */ }
        setLoading(false);
    };

    return (
        <AuthLayout links={<><Link to="/login">Ulogujte se</Link><Link to="/register">Registracija</Link></>}>
            {done ? (
                <div className="auth-text">Kod za promenu lozinke je poslat na Vašu e-mail adresu.</div>
            ) : (
                <form onSubmit={submit} noValidate>
                    <AuthField icon="bi-envelope" error={!ok && EMAIL_ERR}>
                        <InputText type="email" placeholder="E-mail adresa" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
                    </AuthField>
                    <Button type="submit" label="Pošalji" loading={loading} disabled={loading || !ok} />
                </form>
            )}
        </AuthLayout>
    );
}
